/* Theme customised by D Mall Pvt. Ltd. (D MALL SMC LTD.) - dmallofficial.com - All rights reserved */
(function(){
  function pad(n){return n<10?'0'+n:''+n}
  function endFor(el){
    var mode=el.getAttribute('data-mode')||'daily',now=new Date();
    if(mode==='fixed'){var t=Date.parse(el.getAttribute('data-end')||'');if(!isNaN(t))return t;}
    var d=new Date(now);d.setHours(23,59,59,999);return d.getTime();
  }
  function init(el){
    var end=endFor(el);
    var h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]'),dd=el.querySelector('[data-d]');
    function tick(){
      var diff=Math.max(0,end-Date.now());
      var days=Math.floor(diff/864e5),hrs=Math.floor(diff%864e5/36e5),min=Math.floor(diff%36e5/6e4),sec=Math.floor(diff%6e4/1e3);
      if(dd){dd.textContent=pad(days)}else{hrs+=days*24}
      if(h)h.textContent=pad(hrs);if(m)m.textContent=pad(min);if(s)s.textContent=pad(sec);
      if(diff===0&&el.getAttribute('data-mode')!=='fixed'){end=endFor(el)}
    }
    tick();setInterval(tick,1000);
  }
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.querySelectorAll('[data-pcd]').forEach(init);
    var items=document.querySelectorAll('.pm-reveal');
    if(!('IntersectionObserver' in window)){items.forEach(function(i){i.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.12});
    items.forEach(function(i,idx){i.style.transitionDelay=(idx%4)*80+'ms';io.observe(i)});
  });
})();

/* ===== v2: delivery timeline, progress bar, ripple ===== */
(function(root){
  function addWork(d,n,skip){var x=new Date(d.getTime()),c=0;while(c<n){x.setDate(x.getDate()+1);if(!(skip&&x.getDay()===0))c++}return x}
  function sameDay(a,b){return a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate()}
  function compute(now,o){
    var sunday=o.skip&&now.getDay()===0;
    var before=!sunday&&now.getHours()<o.cutoff;
    var dispatch=before?new Date(now.getTime()):addWork(now,1,o.skip);
    var cutAt=new Date(now.getFullYear(),now.getMonth(),now.getDate(),o.cutoff,0,0,0);
    return {before:before,dispatch:dispatch,dmin:addWork(dispatch,o.min,o.skip),dmax:addWork(dispatch,o.max,o.skip),cutMs:cutAt-now,sunday:sunday};
  }
  root.__pmDelivery={compute:compute,addWork:addWork,sameDay:sameDay};
  if(typeof document==='undefined')return;
  function fmt(d){try{return d.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short'})}catch(e){return d.toDateString().slice(0,10)}}
  function rel(d,now){if(sameDay(d,now))return 'Today';var t=new Date(now.getTime());t.setDate(t.getDate()+1);return sameDay(d,t)?'Tomorrow':fmt(d)}
  function pad(n){return n<10?'0'+n:''+n}
  function initDL(el){
    var o={min:+el.dataset.min||2,max:Math.max(+el.dataset.max||4,+el.dataset.min||2),cutoff:+el.dataset.cutoff||18,skip:el.dataset.skipsun!=='false'};
    var cut=el.querySelector('[data-cut]');
    function q(k){return el.querySelector('[data-d="'+k+'"]')}
    function render(){
      var now=new Date(),r=compute(now,o);
      q('dispatch').textContent=rel(r.dispatch,now);
      q('deliver').textContent=o.min===o.max?fmt(r.dmin):fmt(r.dmin)+' - '+fmt(r.dmax);
      if(r.before){var s=Math.max(0,Math.floor(r.cutMs/1000));
        cut.innerHTML='&#9200; Order in the next <b>'+pad(Math.floor(s/3600))+'h '+pad(Math.floor(s%3600/60))+'m '+pad(s%60)+'s</b> for same-day dispatch'}
      else{cut.innerHTML='&#128230; Order now &mdash; your parcel dispatches <b>'+rel(r.dispatch,now).toLowerCase()+'</b>'}
    }
    render();setInterval(render,1000);
  }
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.querySelectorAll('[data-pm-dl]').forEach(initDL);
    var bar=document.createElement('div');bar.id='pm-prog';document.body.appendChild(bar);
    var tk=false;window.addEventListener('scroll',function(){if(tk)return;tk=true;requestAnimationFrame(function(){
      var h=document.documentElement.scrollHeight-window.innerHeight;bar.style.width=(h>0?Math.min(100,window.scrollY/h*100):0)+'%';tk=false})},{passive:true});
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('.pm-btn,.product-form__cart-submit,.pm-fl-btn');if(!b)return;
      var r=b.getBoundingClientRect(),d=Math.max(r.width,r.height),s=document.createElement('span');
      s.className='pm-ripple';s.style.cssText='width:'+d+'px;height:'+d+'px;left:'+(e.clientX-r.left-d/2)+'px;top:'+(e.clientY-r.top-d/2)+'px';
      if(getComputedStyle(b).position==='static')b.style.position='relative';b.style.overflow='hidden';b.appendChild(s);setTimeout(function(){s.remove()},650)});
  });
})(typeof window!=='undefined'?window:globalThis);

/* ===== D Mall: Buy Now (add to cart -> checkout) ===== */
(function(){
  if(typeof document==='undefined'||window.__dmBuyNow)return;window.__dmBuyNow=true;
  function root(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/'}
  function showErr(btn,msg){
    var p=btn.parentNode.querySelector('.dm-buynow-error');
    if(!p){p=document.createElement('p');p.className='dm-buynow-error';btn.insertAdjacentElement('afterend',p)}
    p.textContent=msg;setTimeout(function(){p&&p.remove()},6000);
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-dm-buynow]');if(!btn)return;
    e.preventDefault();e.stopPropagation();
    if(btn.disabled||btn.classList.contains('is-loading'))return;
    var form=btn.closest('form');if(!form){return}
    var terms=form.querySelector('#prTearm,input[name="tearm"][required]');
    if(terms&&!terms.checked){terms.focus();showErr(btn,'Please accept the terms & conditions first.');return}
    var fd=new FormData(form);
    if(!fd.get('id')){var s=form.querySelector('[name="id"]');if(s)fd.set('id',s.value)}
    var q=parseInt(fd.get('quantity'),10);fd.set('quantity',q>0?q:1);
    btn.classList.add('is-loading');
    fetch(root()+'cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){window.location.href=root()+'checkout'})
      .catch(function(err){btn.classList.remove('is-loading');showErr(btn,(err&&(err.description||err.message))||'Something went wrong. Please try again.')});
  },true);
  /* keep Buy Now enabled/disabled in sync with the theme's Add to Cart button on variant change */
  function sync(addBtn){
    var f=addBtn.closest('form');if(!f)return;
    f.querySelectorAll('[data-dm-buynow]').forEach(function(b){b.disabled=addBtn.disabled});
  }
  function start(){
    if(!('MutationObserver' in window))return;
    new MutationObserver(function(ms){ms.forEach(function(m){
      var t=m.target;if(t.matches&&t.matches('button[name="add"],[type="submit"][name="add"]'))sync(t)})})
      .observe(document.body,{subtree:true,attributes:true,attributeFilter:['disabled']});
  }
  document.readyState!=='loading'?start():document.addEventListener('DOMContentLoaded',start);
})();

/* ===== D Mall: Native Buy Now decorate (icon + text + arrow) — EasySell compatible ===== */
(function(){
  if(typeof document==='undefined')return;
  var ICON='<svg class="dm-buynow__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7V6a5 5 0 0 1 10 0v1h2.2a1 1 0 0 1 1 .92l1 13A1 1 0 0 1 20.2 22H3.8a1 1 0 0 1-1-1.08l1-13A1 1 0 0 1 4.8 7H7zm2 0h6V6a3 3 0 0 0-6 0v1zm-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>';
  var ARROW='<svg class="dm-buynow__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function esc(t){var d=document.createElement('div');d.textContent=t;return d.innerHTML}
  function run(){
    document.querySelectorAll('[data-dm-native-buynow]').forEach(function(w){
      var b=w.querySelector('.shopify-payment-button__button--unbranded');
      if(!b||b.getAttribute('data-dm-done'))return;
      b.setAttribute('data-dm-done','1');
      var t=w.getAttribute('data-text')||b.textContent;
      b.innerHTML=ICON+'<span class="dm-buynow__text">'+esc(t)+'</span>'+ARROW;
    });
  }
  function start(){run();if('MutationObserver' in window)new MutationObserver(run).observe(document.body,{childList:true,subtree:true})}
  document.readyState!=='loading'?start():document.addEventListener('DOMContentLoaded',start);
})();

/* fallback for browsers without :has() */
(function(){if(typeof document==='undefined')return;function run(){document.querySelectorAll('[data-dm-hide-atc]').forEach(function(b){var f=b.closest('form');if(f)f.classList.add('dm-only-buynow')})}
document.readyState!=='loading'?run():document.addEventListener('DOMContentLoaded',run);
if('MutationObserver' in window)document.addEventListener('DOMContentLoaded',function(){new MutationObserver(run).observe(document.body,{childList:true,subtree:true})});})();

/* ===== Collections auto slider (infinite loop) ===== */
(function(){
  if(typeof document==='undefined')return;
  function init(root){
    if(root.__pmSl)return;root.__pmSl=true;
    var track=root.querySelector('.pm-col-g');if(!track)return;
    var items=[].slice.call(track.children);var n=items.length;if(n<2)return;
    items.forEach(function(it){var c=it.cloneNode(true);c.setAttribute('aria-hidden','true');c.tabIndex=-1;track.appendChild(c)});
    var idx=0,timer=null,speed=+root.dataset.speed||3000,busy=false;
    function step(){var a=track.children[0],b=track.children[1];return b.offsetLeft-a.offsetLeft}
    function go(i,anim){track.classList.toggle('no-anim',!anim);track.style.transform='translate3d('+(-i*step())+'px,0,0)';idx=i}
    function settle(){busy=false;if(idx>=n){go(idx-n,false)}}
    function arm(){clearTimeout(root.__pmT);root.__pmT=setTimeout(function(){if(busy)settle()},1000)}
    function next(){if(busy)return;busy=true;go(idx+1,true);arm()}
    function prev(){if(busy)return;busy=true;if(idx===0){go(n,false);track.offsetWidth}go(idx-1,true);arm()}
    track.addEventListener('transitionend',function(e){if(e.target!==track||e.propertyName!=='transform')return;settle()});
    function play(){stop();timer=setInterval(next,speed)}
    function stop(){if(timer)clearInterval(timer);timer=null}
    var p=root.querySelector('[data-pm-prev]'),q=root.querySelector('[data-pm-next]');
    if(p)p.addEventListener('click',function(){prev();play()});
    if(q)q.addEventListener('click',function(){next();play()});
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',play);
    var sx=0,sy=0;
    root.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;stop()},{passive:true});
    root.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){dx<0?next():prev()}play()},{passive:true});
    document.addEventListener('visibilitychange',function(){document.hidden?stop():play()});
    window.addEventListener('resize',function(){busy=false;go(idx%n,false)});
    go(0,false);play();
  }
  function run(){document.querySelectorAll('[data-pm-slider]').forEach(init)}
  document.readyState!=='loading'?run():document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
})();

/* ===== Product showcase: gallery + live sold counter ===== */
(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.querySelectorAll('.pm-sc').forEach(function(sc){
      var imgs=sc.querySelectorAll('.pm-sc-img'),ths=sc.querySelectorAll('.pm-sc-th');
      ths.forEach(function(t){t.addEventListener('click',function(){
        var i=+t.getAttribute('data-idx');
        imgs.forEach(function(m,k){m.classList.toggle('is-on',k===i)});
        ths.forEach(function(x){x.classList.toggle('is-on',x===t)});
      })});
      var n=sc.querySelector('[data-sold-n]');
      if(n){var v=parseInt(n.textContent,10)||100;
        setInterval(function(){if(document.hidden)return;v+=1+Math.floor(Math.random()*2);n.textContent=v},9000+Math.random()*6000);}
    });
  });
})();

/* ===== Flash deals: auto slide ===== */
(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    document.querySelectorAll('.pm-fl-track[data-autoslide="true"]').forEach(function(tr){
      var delay=(parseInt(tr.getAttribute('data-speed'),10)||3)*1000,paused=false,timer=null,resume=null;
      function step(){
        if(paused||document.hidden)return;
        var card=tr.querySelector('.pm-fl-card');if(!card)return;
        var w=card.getBoundingClientRect().width+16;
        if(tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4){tr.scrollTo({left:0,behavior:'smooth'})}
        else{tr.scrollBy({left:w,behavior:'smooth'})}
      }
      function start(){clearInterval(timer);timer=setInterval(step,delay)}
      function hold(){paused=true;clearTimeout(resume)}
      function release(ms){clearTimeout(resume);resume=setTimeout(function(){paused=false},ms||1500)}
      tr.addEventListener('mouseenter',hold);tr.addEventListener('mouseleave',function(){release(600)});
      tr.addEventListener('touchstart',hold,{passive:true});tr.addEventListener('touchend',function(){release(3000)},{passive:true});
      tr.addEventListener('focusin',hold);tr.addEventListener('focusout',function(){release(600)});
      start();
    });
  });
})();

/* ===== Hero sparks, trending toast, tab-title nudge ===== */
(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  ready(function(){
    var sp=document.querySelector('.pm-sparks');
    if(sp&&!reduce){
      var ic=['\u2728','\uD83D\uDD25','\uD83C\uDFF7\uFE0F','\u2B50','\uD83D\uDCA5'],n=window.innerWidth<700?8:16;
      for(var i=0;i<n;i++){var e=document.createElement('i');e.textContent=ic[i%ic.length];
        e.style.left=Math.random()*100+'%';e.style.fontSize=(12+Math.random()*16)+'px';
        e.style.animationDuration=(7+Math.random()*7)+'s';e.style.animationDelay=(-Math.random()*12)+'s';sp.appendChild(e)}
    }
    var box=document.getElementById('pm-toast'),list=window.pmToast;
    if(box&&list&&list.length){
      var k=Math.floor(Math.random()*list.length),shown=0,off=false;
      try{off=sessionStorage.getItem('pmToastOff')==='1'}catch(e){}
      var a=box.querySelector('.pm-toast-a'),im=a.querySelector('img'),tt=a.querySelector('b'),pp=a.querySelector('em');
      box.querySelector('.pm-toast-x').addEventListener('click',function(){off=true;box.classList.remove('is-on');try{sessionStorage.setItem('pmToastOff','1')}catch(e){}});
      function show(){
        if(off||shown>=6||document.hidden){return}
        var it=list[k++%list.length];shown++;
        a.href=it.u;if(it.i){im.src=it.i;im.style.display=''}else{im.removeAttribute('src');im.style.display='none'}tt.textContent=it.t;pp.textContent=it.p;
        box.hidden=false;requestAnimationFrame(function(){box.classList.add('is-on')});
        setTimeout(function(){box.classList.remove('is-on')},6000);
      }
      setTimeout(function(){show();setInterval(show,20000)},9000);
    }
    var orig=document.title,t=null;
    document.addEventListener('visibilitychange',function(){
      if(document.hidden){var f=0;t=setInterval(function(){document.title=(f++%2)?'\uD83D\uDD25 Sale ends soon!':'\uD83D\uDECD\uFE0F Your deal is waiting'},1500)}
      else{clearInterval(t);document.title=orig}
    });
  });
})();

/* ===== EasySell COD: keep ONE buy button =====
   No EasySell  -> theme's own Buy Now shows (1 button).
   EasySell     -> EasySell's button takes over, theme's Buy Now hides (still 1 button).
   Debug: open any product page with ?dmdebug=1 to see what was detected. */
(function(){
  if(typeof document==='undefined')return;
  var WORDS=/buy|order|\bcod\b|cash|checkout|complete|place/i;
  var SKIP='.dm-buynow,.dm-buynow-native,.dm-buynow__note,header,footer,.pm-sc-links,[name="add"],.product-form__cart-submit,[class*="sticky"],.btn-wishlist,.wishlist,.qtyBtn,.prlightbox,.popup-video,.pr360view';
  var BTN='button,input[type="button"],input[type="submit"],[role="button"]';
  var DEBUG=/[?&]dmdebug\b/.test(location.search);
  function shown(el){return !!(el.offsetWidth||el.offsetHeight||(el.getClientRects&&el.getClientRects().length))}
  function skip(el){try{return el.matches(SKIP)||!!el.closest(SKIP)}catch(e){return false}}
  function deep(root,sel,out){
    [].forEach.call(root.querySelectorAll(sel),function(e){out.push(e)});
    [].forEach.call(root.querySelectorAll('*'),function(e){if(e.shadowRoot)deep(e.shadowRoot,sel,out)});
    return out;
  }
  function label(b){return (b.value||b.getAttribute('aria-label')||b.textContent||'').replace(/\s+/g,' ').trim()}
  function marker(e){var c=e.getAttribute&&e.getAttribute('class')||'';return /easysell|easy-sell/i.test(e.tagName+' '+c+' '+(e.id||''))}
  function find(scope){
    var hits=[];
    deep(scope,BTN,[]).forEach(function(b){
      if(skip(b)||!shown(b))return;
      var t=label(b);
      if(t.length>0&&t.length<80&&WORDS.test(t)&&!/whatsapp/i.test(t))hits.push(b);
    });
    [].forEach.call(scope.querySelectorAll('*'),function(e){
      if(marker(e)&&!skip(e)&&shown(e)&&hits.indexOf(e)<0)hits.push(e);
    });
    return hits;
  }
  function note(lines){
    var n=document.getElementById('dm-debug');
    if(!n){n=document.createElement('pre');n.id='dm-debug';n.style.cssText='position:fixed;z-index:99999;left:8px;bottom:8px;max-width:92vw;max-height:45vh;overflow:auto;margin:0;padding:10px;background:#111;color:#8f8;font:11px/1.35 monospace;white-space:pre-wrap;border-radius:8px';document.body.appendChild(n)}
    n.textContent=lines.join('\n');
  }
  function run(){
    var seen=[],log=[];
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
      var scope=f.closest('[id^="shopify-section"]')||f.parentElement||document.body;
      if(seen.indexOf(scope)>-1)return;seen.push(scope);
      var mine=[].slice.call(scope.querySelectorAll('.dm-buynow,.dm-buynow__note,.dm-buynow-native'));
      var hits=find(scope);
      if(mine.length)mine.forEach(function(x){x.classList.toggle('dm-es-hide',hits.length>0)});
      if(DEBUG){
        log.push('SECTION '+(scope.id||scope.className)+' | theme buy buttons: '+mine.length+' | other buy buttons found: '+hits.length+(hits.length?' -> theme Buy Now HIDDEN':' -> theme Buy Now SHOWN'));
        hits.forEach(function(h){log.push('  FOUND <'+h.tagName.toLowerCase()+' class="'+(h.getAttribute('class')||'')+'" id="'+(h.id||'')+'"> "'+label(h).slice(0,50)+'"')});
        deep(scope,BTN,[]).forEach(function(b){if(shown(b))log.push('  button <'+b.tagName.toLowerCase()+' class="'+(b.getAttribute('class')||'').slice(0,60)+'"> "'+label(b).slice(0,40)+'"'+(skip(b)?' [theme]':''))});
      }
    });
    if(DEBUG)note(log.length?log:['no product form found on this page']);
  }
  var t=null;function later(){clearTimeout(t);t=setTimeout(run,120)}
  function start(){run();[500,1200,2500,5000,9000].forEach(function(ms){setTimeout(run,ms)});
    if('MutationObserver' in window)new MutationObserver(later).observe(document.body,{childList:true,subtree:true})}
  document.readyState!=='loading'?start():document.addEventListener('DOMContentLoaded',start);
})();

/* D Mall Pvt. Ltd. - licence guard */
(function(){setTimeout(function(){if(window.__dmSig)return;var h=document.getElementById("dmall-sig");if(!h){h=document.createElement("div");h.id="dmall-sig";(document.querySelector(".site-footer")||document.body).appendChild(h)}
h.innerHTML='<a href="https://dmallofficial.com" target="_blank" rel="noopener" style="display:block!important;text-align:center;padding:16px 10px;background:#070B14;color:#ff8a3d;font:600 12px/1.4 Arial,sans-serif;letter-spacing:1.5px;text-decoration:none">DESIGNED &middot; DEVELOPED &middot; CERTIFIED BY <b style="color:#fff">D MALL PVT. LTD.</b></a>';
h.style.setProperty("display","block","important");h.style.setProperty("visibility","visible","important");h.style.setProperty("opacity","1","important")},4000)})();
